import { render } from "./Share.vue?vue&type=template&id=00fa7f34"
import script from "./Share.vue?vue&type=script&lang=js"
export * from "./Share.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Programming\\Padmaweb\\client\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__